import { STORAGE_KEYS } from '~/utils/storage'

export const ALBUM_LAYOUT_OPTIONS = [
  { value: 'dense', label: '密集', columns: 3, icon: 'fa-solid fa-grip' },
  { value: 'relaxed', label: '宽松', columns: 2, icon: 'fa-solid fa-table-cells-large' },
  { value: 'immersive', label: '沉浸', columns: 1, icon: 'fa-regular fa-image' }
] as const

export type AlbumLayout = (typeof ALBUM_LAYOUT_OPTIONS)[number]['value']

// useAlbumLayout 独立保存桌面布局，移动端固定使用沉浸布局
export const useAlbumLayout = (scope: 'list' | 'detail') => {
  const storageKey = scope === 'list' ? STORAGE_KEYS.ALBUM_LIST_LAYOUT : STORAGE_KEYS.ALBUM_DETAIL_LAYOUT
  const savedLayout = useState<AlbumLayout>(`blog-album-${scope}-layout`, () => 'dense')
  // 首屏按沉浸条数加载，避免移动端挂载前请求桌面批次
  const isMobile = ref(true)
  const layout = computed({
    get: () => isMobile.value ? 'immersive' : savedLayout.value,
    set: (value: AlbumLayout) => { savedLayout.value = value }
  })
  const columns = computed(() => ALBUM_LAYOUT_OPTIONS.find(option => option.value === layout.value)!.columns)
  const batchSize = computed(() => columns.value * 3)
  let mobileQuery: MediaQueryList | null = null

  // syncViewport 按相册瀑布流断点同步移动端状态
  const syncViewport = () => {
    isMobile.value = mobileQuery!.matches
  }

  onMounted(() => {
    try {
      const saved = localStorage.getItem(storageKey)
      const option = ALBUM_LAYOUT_OPTIONS.find(item => item.value === saved)
      if (option) {
        savedLayout.value = option.value
      }
    } catch {
      // localStorage 不可用时保留当前布局
    }
    mobileQuery = window.matchMedia('(max-width: 640px)')
    syncViewport()
    mobileQuery.addEventListener('change', syncViewport)
    // 页面完成布局同步后移除首屏样式标记，避免影响后续切换
    nextTick(() => {
      delete document.documentElement.dataset[scope === 'list' ? 'albumListLayout' : 'albumDetailLayout']
    })
  })

  onBeforeUnmount(() => mobileQuery?.removeEventListener('change', syncViewport))

  watch(savedLayout, value => {
    if (!import.meta.client) {
      return
    }
    try {
      localStorage.setItem(storageKey, value)
    } catch {
      // localStorage 不可用时仅保留当前布局
    }
  })

  return { layout, columns, batchSize }
}
